import kamala from '../../kamala'
import InputNumber from './InputNumber'

InputNumber.install = function (Vue) {
  kamala(Vue)
  Vue.component(InputNumber.name, InputNumber)
}

export default InputNumber
